export enum AlertType {
    Success = 'success',
    Info = 'info',
    Error = 'error',
    Warning = 'warning'
}
